import { CSSProperties, ReactNode } from 'react';

export interface TableProps {
  children?: ReactNode | JSX.Element | string | undefined;
  style?: CSSProperties;
}

export function Table({ children, style, ...rest }: TableProps) {
  return (
    <table className="table-container" style={style} {...rest}>
      {children}
    </table>
  );
}
